/* eslint-disable */
import { useState } from 'react';
import './App.css';

import Login     from './pages/Login';
import Dashboard from './pages/Dashboard';
import Sidebar   from './components/Sidebar';
import Pengadaan from './pages/Pengadaan';
import Keuangan  from './pages/Keuangan';
import Proyek    from './pages/Proyek';
import ManajemenUser from './pages/ManajemenUser';
import Gudang from './pages/Gudang';
import MasterData from './pages/MasterData';
import Absensi from './pages/Absensi';


function App() {

  // State: halaman mana yang aktif
  const [halaman,   setHalaman]   = useState('dashboard');

  // State: data user yang sedang login (null = belum login)
  const [user, setUser] = useState(function() {
    const sesi = localStorage.getItem('erp_user');
    if (!sesi) return null;
    try {
      return JSON.parse(sesi);
    } catch (err) {
      // Data tersimpan rusak/tidak valid — bersihkan supaya app tidak crash blank putih
      localStorage.removeItem('erp_token');
      localStorage.removeItem('erp_user');
      return null;
    }
  });

  // State: modal logout
  const [showLogout, setShowLogout] = useState(false);

  // State: sidebar disembunyikan/ditampilkan
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Fungsi login berhasil
  function handleLogin(userData) {
    setUser(userData);
    setHalaman('dashboard');
  }

  // Fungsi logout
  function handleLogout() {
  localStorage.removeItem('erp_token');
  localStorage.removeItem('erp_user');
  setUser(null);
  setShowLogout(false);
}

  // Jika belum login → tampilkan halaman Login
  if (!user) {
    return <Login onLoginBerhasil={handleLogin} />;
  }

  // Tentukan konten berdasarkan menu aktif
  function renderHalaman() {
    switch (halaman) {
      case 'dashboard': return <Dashboard user={user} />;
      case 'pengadaan': return <Pengadaan user={user} />;
      case 'keuangan':  return <Keuangan user={user} />;
      case 'proyek':
        return (
          <main className="main-content">
            <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚧</div>
              <h3 style={{ color: '#1a3a5c', marginBottom: '8px' }}>
                Halaman "Proyek" sedang dibangun
              </h3>
              <p style={{ color: '#888' }}>
                Akan ditambahkan di iterasi berikutnya
              </p>
            </div>
          </main>
        );

      case 'user-management': return <ManajemenUser user={user} />;
      case 'gudang': return <Gudang user={user} />;
      case 'master-data': return <MasterData user={user} />;
      case 'absensi':
        return (
          <main className="main-content">
            <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚧</div>
              <h3 style={{ color: '#1a3a5c', marginBottom: '8px' }}>
                Halaman "Absensi" sedang dibangun
              </h3>
              <p style={{ color: '#888' }}>
                Akan ditambahkan di iterasi berikutnya
              </p>
            </div>
          </main>
        );
        
      default:
        return (
          <main className="main-content">
            <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚧</div>
              <h3 style={{ color: '#1a3a5c', marginBottom: '8px' }}>
                Halaman "{halaman}" sedang dibangun
              </h3>
              <p style={{ color: '#888' }}>
                Akan ditambahkan di iterasi berikutnya
              </p>
            </div>
          </main>
        );
    }
  }

  return (
    <div className={`app-layout ${sidebarCollapsed ? 'collapsed' : ''}`} id="app-layout">

      {/* SIDEBAR */}
      <Sidebar
        menuAktif={halaman}
        onMenuKlik={setHalaman}
        user={user}
        onLogout={() => setShowLogout(true)}
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(c => !c)}
      />

      {/* MAIN CONTENT */}
      <div className="main-wrapper">
        {renderHalaman()}
      </div>

      {/* MODAL LOGOUT */}
      {showLogout && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3> <img src="logout.png" alt="Logout" width="20px" height="20px" /> Keluar dari Sistem?</h3>
            <p>Pastikan semua pekerjaan sudah tersimpan.</p>
            <div className="modal-actions">
              <button className="btn-cancel"  onClick={() => setShowLogout(false)}>Batal</button>
              <button className="btn-confirm" onClick={handleLogout}>Ya, Keluar</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}


export default App;